import React from 'react';
import { useFadeIn } from '../hooks/useFadeIn';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function GuaranteeSection() {
  const fadeIn = useFadeIn();
  return <section className="py-10 md:py-20 px-4 bg-black text-white border-t-8 border-yellow-400" data-id="element-125">
      <div className="max-w-3xl mx-auto text-center" data-id="element-126">
        <div ref={fadeIn.ref} className={fadeIn.className} data-id="element-127">
          <ShieldCheckIcon className="w-16 h-16 md:w-24 md:h-24 text-yellow-400 mx-auto mb-4 md:mb-6" data-id="element-128" />

          <h2 className="text-3xl md:text-5xl font-black text-white mb-6 md:mb-8 uppercase tracking-wide" data-id="element-129">
            🔒 OUR 7-DAY TOTAL GUARANTEE
          </h2>

          <div className="text-lg md:text-2xl text-gray-300 space-y-3 md:space-y-4 mb-8 md:mb-12 max-w-2xl mx-auto font-medium" data-id="element-130">
            <p data-id="element-131">
              Download the full system. Print some activities and use them with
              your child.
            </p>
            <p data-id="element-132">
              If within 7 days you don't see a real difference in their focus,
              confidence and willingness to learn — we'll refund every single
              cent. No forms. No drama.
            </p>
            <p className="text-yellow-400 font-bold" data-id="element-133">
              Return rate: less than 1%.
            </p>
          </div>

          <div className="bg-gray-900 border border-gray-800 p-6 md:p-8 rounded-2xl mb-8 md:mb-12 shadow-2xl" data-id="element-134">
            <h3 className="text-2xl md:text-3xl font-black text-blue-500 mb-3 md:mb-4" data-id="element-135">
              💙 Your child's brain is developing right now
            </h3>
            <p className="text-xl md:text-2xl font-bold text-white mb-2" data-id="element-136">
              Every single day.
            </p>
            <p className="text-xl md:text-2xl font-bold text-yellow-400 mb-3 md:mb-4" data-id="element-137">
              The question isn't whether they'll grow. The question is what
              you're building them with.
            </p>
            <p className="text-base md:text-lg text-gray-400 font-medium" data-id="element-138">
              Give your child the cognitive foundation that lasts a lifetime.
            </p>
          </div>

          <div className="max-w-md mx-auto" data-id="element-139">
            <CTAButton text="👉 GET THE LITTLE GENIUS SYSTEM™ NOW" size="sm" data-id="element-140" />
          </div>
        </div>
      </div>
    </section>;
}